import React from "react";
import _ from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";

import Swal from "helpers/swal";
import Button from "components/Button";
import { connect } from "../../reduxConnector";
import companyInformationActions from "./actions";
import "./style.scss";
import BackgroundBlock from "../deliveryNotes/partials/BackgroundBlock";
import Input from "components/Input";
import Select from "components/Select";
import { localRequest } from "../../apiUtils";
import ICustomer from "models/ICustomer";
import IUser from "models/IUser";
import CNBDatePicker from "components/CNBDatePicker";
import URLS from "../../constants/urlConstants";
import { Link } from "react-router-dom";

interface IProps {
  getCompanyInformation: () => void;
  currentCustomer: ICustomer;
  user: IUser;
  intl: any;
  userName: string;
  userLanguage: string;
  companyInformation: any;
  history: any;
}

interface IState {
  [key: string]: any;
  loading: boolean;
  error: any;
  touched: any;
  isFormValid: boolean;
  Number: string;
  Name: string;
  LegalForm: string;
  KvKNumber: string;
  OfficeNumber: string;
  MailAddress: string;
  correspondentieadres: string;
  correspondentiepostcode: string;
  correspondentieplaats: string;
  correspondentieland: string;
  vestigingsadres: string;
  vestigingsland: string;
  afleveradres: string;
  BankAccount: string;
  BankAccountSwift: string;
  VATPostingGroup: string;
  Exporter: string;
  VATNumber: string;
  BKDNumber: string;
  NAKTNumber: string;

  Certificates: Array<{
    Participation: string;
    RegistrationNumber: string;
    CertificationOrganization: string;
  }>;
  FytosanitairNumber: string;
  CNBMember: string;
  CNBMemberFrom: string;
  EDICode: string;
  DigitalCommunication: string;
}

class CompanyInformationEdit extends React.Component<IProps, IState> {
  private baseState: Readonly<any>;
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      isFormValid: false,
      error: null,
      touched: {},
      Number: "",
      Name: "",
      LegalForm: "",
      KvKNumber: "",
      OfficeNumber: "",
      MailAddress: "",
      correspondentieadres: "",
      correspondentiepostcode: "",
      correspondentieplaats: "",
      correspondentieland: "",
      vestigingsadres: "",
      vestigingspostcode: "",
      vestigingsplaats: "",
      vestigingsland: "",
      afleveradres: "",
      afleverpostcode: "",
      afleverplaats: "",
      afleverland: "",
      Certificates: [
        {
          Participation: "",
          RegistrationNumber: "",
          CertificationOrganization: "",
        },
      ],
      BankAccount: "",
      BankAccountSwift: "",
      VATPostingGroup: "",
      Exporter: "",
      VATNumber: "",
      BTW_nummer: "",
      BKDNumber: "",
      NAKTNumber: "",
      FytosanitairNumber: "",
      CNBMember: "",
      CNBMemberFrom: "",
      EDICode: "",
      DigitalCommunication: "",
    };
  }

  public componentDidMount() {
    const { getCompanyInformation } = this.props;
    getCompanyInformation();
  }

  public async componentDidUpdate(
    prevProps: Readonly<any>,
    prevState: Readonly<IState>,
    snapshot?: any
  ) {
    if (prevState.Certificates !== this.state.Certificates) {
      this.validateLines();
    }
    if (prevProps.companyInformation !== this.props.companyInformation) {
      const { companyInformation } = this.props;
      await this.mapDataToState(companyInformation);
      this.baseState = this.state;
    }
  }

  private async mapDataToState(companyInformation) {
    Object.entries(companyInformation).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        if (key === "Certificates") {
          const newValue = value.map((item) => ({
            Participation: item.Participation,
            RegistrationNumber: item.RegistrationNumber,
            CertificationOrganization: item.CertificationOrganization,
          }));
          this.setState({
            [key]: newValue,
          });
        } else {
          // check typeId of each array item
          companyInformation[key].forEach((item) => {
            switch (item.TypeId) {
              case "PostAdres":
                this.setState({
                  correspondentieadres: item.Address1,
                  correspondentiepostcode: item.ZipCode,
                  correspondentieplaats: item.City,
                  correspondentieland: item.Country.Code,
                });
                break;
              case "VestigingsAdres":
                this.setState({
                  vestigingsadres: item.Address1,
                  vestigingspostcode: item.ZipCode,
                  vestigingsplaats: item.City,
                  vestigingsland: item.Country.Code,
                });
                break;
              case "LeverAdres":
                this.setState({
                  afleveradres: item.Address1,
                  afleverpostcode: item.ZipCode,
                  afleverplaats: item.City,
                  afleverland: item.Country.Code,
                });
                break;
            }
          });
        }
      } else if (typeof value === "boolean") {
        this.setState({
          [key]: value ? "Ja" : "Nee",
        });
      } else if (typeof value === "object") {
        const _key = "Description";
        this.setState({
          [key]: value ? value[_key] : "",
        });
      } else {
        this.setState({
          [key]: value,
        });
      }
    });
  }
  private handleFieldChange(name, value) {
    this.setState({ [name]: value });
    this.validateLines();
  }

  private handleDeleteRow = (e: Event, index: number) => {
    e.preventDefault();
    const updatedList = [...this.state.Certificates];
    updatedList.splice(index, 1);
    this.setState({
      Certificates: updatedList,
    });
  };

  private handleAddRow = (e) => {
    e.preventDefault();
    const emptyState = {
      Participation: "",
      RegistrationNumber: "",
      CertificationOrganization: "",
    };

    this.setState({
      Certificates: this.state.Certificates.concat([emptyState]),
    });
  };

  private handleCertificaatChange = (e: any, index: number) => {
    const { target } = e;
    const updatedValues = this.state.Certificates.map(
      (transaction, i: number) => {
        return index === i
          ? { ...transaction, ...{ [target.name]: target.value } }
          : transaction;
      }
    );
    this.setState({
      ...this.state,
      Certificates: [...updatedValues],
    });
    this.validateLines();
  };

  private validateLines(): boolean {
    let isLineFilled = false;
    const { Certificates } = this.state;

    if (Certificates.length > 0) {
      for (let index = 0; index < Certificates.length; index++) {
        isLineFilled = Object.values(Certificates[index]).every(
          (value) => value !== "" && value !== null
        );

        if (isLineFilled) {
          this.setState({ isFormValid: true });
        } else {
          this.setState({ isFormValid: false });
          break;
        }
      }
    }
    if (Certificates.length < 1) {
      this.setState({ isFormValid: true });
      return true;
    }

    return isLineFilled;
  }

  private getChangedFields = () => {
    const changedValues: any[] = [];
    Object.entries(this.state).forEach(([key, val]) => {
      if (val !== this.baseState[key]) {
        changedValues.push({
          key,
          newValue: val,
          oldValue: this.baseState[key],
        });
      }
    });
    return changedValues.filter((item) => item.key !== "isFormValid");
  };

  private handleSubmitForm = async (e) => {
    e.preventDefault();
    const { history } = this.props;
    this.setState({ loading: true });
    const {
      intl: { formatMessage },
    } = this.props;
    const changedFields = this.getChangedFields();
    const requestPayload = {
      email: this.props.userName,
      language: this.props.userLanguage,
      nawChanges: changedFields,
      customerNumber: this.state.Number,
      MailAddress: this.state.MailAddress,
    };
    try {
      const { status } = await localRequest.post(
        "email/send-naw-email",
        requestPayload
      );
      if (status === 200) {
        this.setState({ loading: false });
        // fire success message
        Swal.alert(
          "succes",
          `${formatMessage({ id: "COMPANY_UPDATE_MESSAGE" })}`
        ).then(() => {
          history.push(URLS.HOME_URL);
        });
      }
      this.setState({ loading: false });
    } catch (e) {
      Swal.alert(
        "error",
        `${formatMessage({ id: "COMPANY_UPDATE_ERROR_MESSAGE" })}`
      );
      this.setState({ loading: false });
    }
  };

  public render() {
    const {
      loading,
      Number,
      Name,
      LegalForm,
      KvKNumber,
      OfficeNumber,
      MailAddress,
      correspondentieadres,
      correspondentiepostcode,
      correspondentieplaats,
      correspondentieland,
      vestigingsadres,
      vestigingspostcode,
      vestigingsplaats,
      vestigingsland,
      afleveradres,
      afleverpostcode,
      afleverplaats,
      afleverland,
      BankAccount,
      BankAccountSwift,
      VATPostingGroup,
      Exporter,
      VATNumber,
      BKDNumber,
      NAKTNumber,
      FytosanitairNumber,
      CNBMember,
      CNBMemberFrom,
      EDICode,
      DigitalCommunication,
      Certificates,
      isFormValid,
    } = this.state;

    return (
      <div id="my-deliveries-pagee">
        <div className="child-header">
          <FormattedMessage id="COMPANY_DETAILS" tagName="h1" />
          <div className="child-header-right">
            <div>
              <Link to={URLS.COMPANY_INFORMATION}>
                <a href="#" className="link-text">
                  Terug
                </a>
              </Link>
            </div>
            <Button
              id="create-delivery-top"
              kind="primary"
              className="animate-bg bg-white"
              disabled={!isFormValid}
              form="new-cultivation-advice"
              type="submit"
            >
              SUBMIT
            </Button>
          </div>
        </div>

        <form id="new-cultivation-advice" onSubmit={this.handleSubmitForm}>
          <BackgroundBlock className="advice-form custom-header">
            <FormattedMessage id="COMPANY_DETAILS" tagName="h2" />
          </BackgroundBlock>
          <div className="line-below"></div>

          <div className="company-details-section">
            <div className="company-details-section-one">
              <Input
                name="Number"
                label="CLIENT_NR"
                placeholder="CLIENT_NR"
                value={Number}
                disabled
                onChange={(e) =>
                  this.handleFieldChange("Number", e.target.value)
                }
              />
              <Input
                name="Name"
                label="COMPANY_NAME"
                placeholder="COMPANY_NAME"
                value={Name}
                required
                onChange={(e) => this.handleFieldChange("Name", e.target.value)}
              />
              <Input
                name="LegalForm"
                label="COMPANY_LEGAL_PERSON"
                placeholder="COMPANY_LEGAL_PERSON"
                required
                value={LegalForm}
                onChange={(e) =>
                  this.handleFieldChange("LegalForm", e.target.value)
                }
              />
              <Input
                name="KvKNumber"
                label="COMPANY_KVK_NUMBER"
                placeholder="COMPANY_KVK_NUMBER"
                value={KvKNumber}
                onChange={(e) =>
                  this.handleFieldChange("KvKNumber", e.target.value)
                }
              />
              <Input
                name="OfficeNumber"
                label="COMPANY_PHONE"
                hasTooltip={true}
                tooltipText="COMPANY_PHONE_TOOLTIP"
                placeholder="COMPANY_PHONE"
                required
                value={OfficeNumber}
                onChange={(e) =>
                  this.handleFieldChange("OfficeNumber", e.target.value)
                }
              />
              <Input
                name="MailAddress"
                label="COMPANY_EMAIL"
                hasTooltip={true}
                tooltipText="COMPANY_EMAIL_TOOLTIP"
                placeholder="COMPANY_EMAIL"
                required
                value={MailAddress}
                onChange={(e) =>
                  this.handleFieldChange("MailAddress", e.target.value)
                }
              />
            </div>
            <div className="company-details-section-two">
              <Input
                name="correspondentieadres"
                label="COMPANY_CORRESPONDENCE_ADDRESS"
                placeholder="COMPANY_CORRESPONDENCE_ADDRESS"
                required
                value={correspondentieadres}
                onChange={(e) =>
                  this.handleFieldChange("correspondentieadres", e.target.value)
                }
              />
              <Input
                name="correspondentiepostcode"
                label="COMPANY_CORRESPONDENCE_POSTCODE"
                placeholder="COMPANY_CORRESPONDENCE_POSTCODE"
                required
                value={correspondentiepostcode}
                onChange={(e) =>
                  this.handleFieldChange(
                    "correspondentiepostcode",
                    e.target.value
                  )
                }
              />
              <Input
                name="correspondentieplaats"
                label="COMPANY_CORRESPONDENCE_PLACE"
                placeholder="COMPANY_CORRESPONDENCE_PLACE"
                required
                value={correspondentieplaats}
                onChange={(e) =>
                  this.handleFieldChange(
                    "correspondentieplaats",
                    e.target.value
                  )
                }
              />
              <Input
                name="correspondentieland"
                label="COMPANY_CORRESPONDENCE_COUNTRY"
                placeholder="COMPANY_CORRESPONDENCE_COUNTRY"
                required
                value={correspondentieland}
                onChange={(e) =>
                  this.handleFieldChange("correspondentieland", e.target.value)
                }
              />
              <Input
                name="vestigingsadres"
                label="COMPANY_BUSINESS_ADDRESS"
                placeholder="COMPANY_BUSINESS_ADDRESS"
                required
                value={vestigingsadres}
                onChange={(e) =>
                  this.handleFieldChange("vestigingsadres", e.target.value)
                }
              />
              <Input
                name="vestigingspostcode"
                label="COMPANY_BRANCH_POSTCODE"
                placeholder="COMPANY_BRANCH_POSTCODE"
                required
                value={vestigingspostcode}
                onChange={(e) =>
                  this.handleFieldChange("vestigingspostcode", e.target.value)
                }
              />
              <Input
                name="vestigingsplaats"
                label="COMPANY_LOCATION"
                placeholder="COMPANY_LOCATION"
                required
                value={vestigingsplaats}
                onChange={(e) =>
                  this.handleFieldChange("vestigingsplaats", e.target.value)
                }
              />
              <Input
                name="vestigingsland"
                label="COMPANY_COUNTRY"
                placeholder="COMPANY_COUNTRY"
                required
                value={vestigingsland}
                onChange={(e) =>
                  this.handleFieldChange("vestigingsland", e.target.value)
                }
              />
              <Input
                name="afleveradres"
                label="COMPANY_DELIVERY_ADDRESS"
                placeholder="COMPANY_DELIVERY_ADDRESS"
                value={afleveradres}
                onChange={(e) =>
                  this.handleFieldChange("afleveradres", e.target.value)
                }
              />
              <Input
                name="afleverpostcode"
                label="COMPANY_DELIVERY_POSTCODE"
                placeholder="COMPANY_DELIVERY_POSTCODE"
                value={afleverpostcode}
                onChange={(e) =>
                  this.handleFieldChange("afleverpostcode", e.target.value)
                }
              />
              <Input
                name="afleverplaats"
                label="COMPANY_DELIVERY_PLACE"
                placeholder="COMPANY_DELIVERY_PLACE"
                value={afleverplaats}
                onChange={(e) =>
                  this.handleFieldChange("afleverplaats", e.target.value)
                }
              />
              <Input
                name="afleverland"
                label="COMPANY_DELIVERY_COUNTRY"
                placeholder="COMPANY_DELIVERY_COUNTRY"
                value={afleverland}
                onChange={(e) =>
                  this.handleFieldChange("afleverland", e.target.value)
                }
              />
            </div>
          </div>

          <BackgroundBlock className="advice-form custom-header">
            <FormattedMessage id="COMPANY_FINANCIAL" tagName="h2" />
          </BackgroundBlock>
          <div className="line-below"></div>

          <div className="company-details-section">
            <div className="company-details-section-one">
              <Input
                name="BankAccount"
                label="COMPANY_IBAN"
                placeholder="COMPANY_IBAN"
                required
                value={BankAccount}
                onChange={(e) =>
                  this.handleFieldChange("BankAccount", e.target.value)
                }
              />
              <Input
                name="BankAccountSwift"
                label="COMPANY_SWIFT"
                placeholder="COMPANY_SWIFT"
                required
                value={BankAccountSwift}
                onChange={(e) =>
                  this.handleFieldChange("BankAccountSwift", e.target.value)
                }
              />
            </div>
            <div className="company-details-section-two">
              <Input
                name="BTW_status"
                label="COMPANY_BTW"
                placeholder="COMPANY_BTW"
                disabled
                value={VATPostingGroup}
                onChange={(e) =>
                  this.handleFieldChange("VATPostingGroup", e.target.value)
                }
              />
              <Input
                name="Exporter"
                label="COMPANY_EXPORTER"
                placeholder="COMPANY_EXPORTER"
                disabled
                value={Exporter}
                onChange={(e) =>
                  this.handleFieldChange("Exporter", e.target.value)
                }
              />
              <Input
                name="BTW_nummer"
                label="COMPANY_BTW_NUMBER"
                placeholder="COMPANY_BTW_NUMBER"
                required
                value={VATNumber}
                onChange={(e) =>
                  this.handleFieldChange("VATNumber", e.target.value)
                }
              />
            </div>
          </div>

          <BackgroundBlock className="advice-form custom-header">
            <FormattedMessage id="COMPANY_INFORMATION" tagName="h2" />
          </BackgroundBlock>
          <div className="line-below"></div>

          <div className="company-details-section">
            <div className="company-details-section-one">
              <Input
                name="BKDNumber"
                label="COMPANY_BKD_NUMBER"
                placeholder="COMPANY_BKD_NUMBER"
                value={BKDNumber}
                onChange={(e) =>
                  this.handleFieldChange("BKDNumber", e.target.value)
                }
              />
              <Input
                name="NAKTNumber"
                label="COMPANY_NAKT_NUMBER"
                placeholder="COMPANY_NAKT_NUMBER"
                value={NAKTNumber}
                onChange={(e) =>
                  this.handleFieldChange("NAKTNumber", e.target.value)
                }
              />
              <Input
                name="FytosanitairNumber"
                label="COMPANY_PHYTO_NUMBER"
                placeholder="COMPANY_PHYTO_NUMBER"
                value={FytosanitairNumber}
                onChange={(e) =>
                  this.handleFieldChange("FytosanitairNumber", e.target.value)
                }
              />
            </div>
            <div className="company-details-section-two">
              <div className="section-array">
                <FormattedMessage
                  id="COMPANY_CERTIFICATE_PARTICIPATION"
                  tagName="h4"
                  className="certificate-label"
                />
                <FormattedMessage
                  id="COMPANY_CERTIFICATE_REGISTRATION"
                  tagName="h4"
                  className="certificate-label"
                />
                <FormattedMessage
                  id="COMPANY_CERTIFICATE_ORGANISATION"
                  tagName="h4"
                  className="certificate-label"
                />
                <label className="normalizeSpace">&nbsp;</label>
              </div>
              {Certificates.slice(0, 2).map((certificaat, index) => (
                <div className="section-array">
                  <Input
                    name="Participation"
                    onChange={(e) => this.handleCertificaatChange(e, index)}
                    value={certificaat.Participation}
                    required
                  />
                  <Input
                    name="RegistrationNumber"
                    onChange={(e) => this.handleCertificaatChange(e, index)}
                    value={certificaat.RegistrationNumber}
                    required
                  />
                  <Input
                    name="CertificationOrganization"
                    onChange={(e) => this.handleCertificaatChange(e, index)}
                    value={certificaat.CertificationOrganization}
                    required
                  />
                  <Button
                    kind="primary"
                    type="button"
                    className="p-10 remove-btn"
                    onClick={(e) => this.handleDeleteRow(e, index)}
                  >
                    MINUS_SIGN
                  </Button>
                </div>
              ))}
              <Button
                kind="primary"
                type="button"
                className="add-btn pull-right mt-10"
                onClick={this.handleAddRow}
              >
                PLUS_SIGN
              </Button>
            </div>
          </div>

          <BackgroundBlock className="advice-form custom-header">
            <FormattedMessage id="COMPANY_OTHER_DETAILS" tagName="h2" />
          </BackgroundBlock>
          <div className="line-below"></div>

          <div className="company-details-section">
            <div className="company-details-section-one">
              <Input
                name="CNBMember"
                label="COMPANY_CNB_LID"
                placeholder="COMPANY_CNB_LID"
                hasTooltip={true}
                tooltipText="COMPANY_CNB_MEMBERSHIP_TOOLTIP"
                value={CNBMember}
                disabled
              />
              <CNBDatePicker
                containerClassName="cnb-input"
                className="date-picker"
                name="CNBMemberFrom"
                label="COMPANY_CNB_MEMBER_FORM"
                startDate={
                  CNBMember.toLowerCase() === "ja" ? CNBMemberFrom : null
                }
                disabled
              />

              <Input
                name="EDI_code"
                label="COMPANY_EDI_CODE"
                placeholder="COMPANY_EDI_CODE"
                value={EDICode}
                disabled
              />
            </div>
            <div className="company-details-section-two">
              <Select
                label="COMPANY_DIGITAL"
                name="DigitalCommunication"
                hasTooltip={true}
                tooltipText="COMPANY_DIGITAL_TOOLTIP"
                selectedOption={DigitalCommunication}
                options={[
                  { value: "Ja", label: "Ja" },
                  { value: "Nee", label: "Nee" },
                ]}
                onChange={(e) =>
                  this.handleFieldChange("DigitalCommunication", e.value)
                }
                className="customSelect"
              />
            </div>
          </div>

          <div className="button-container">
            <Button
              type="submit"
              kind="primary"
              className="animate-bg bg-white"
              disabled={!isFormValid || loading}
            >
              SUBMIT
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    companyInformation: state.companyInformation.companyDetail,
    roleIds: state.app.roleIds,
    userLanguage: state.app.user.profile.Language,
    currentCustomer: state.app.currentCustomer,
    userName: state.app.userName,
  }),
  {
    getCompanyInformation:
      companyInformationActions.getCompanyInformationForCustomer,
  }
)(injectIntl(CompanyInformationEdit));
